import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from './styles.scss';

const FieldLabel = ({ children, label, isnLabel }) => (
  <label className={classNames(styles.label, { [styles.green]: isnLabel })}>{children || label}</label>
);

FieldLabel.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  isnLabel: PropTypes.bool,
};

export default FieldLabel;



// WEBPACK FOOTER //
// src/components/shared/FieldLabel/index.jsx